
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/previous-privacy",
      function () {
        return require("private-next-pages/policy/previous-privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/previous-privacy"])
      });
    }
  